import clsx from 'clsx';
import * as React from 'react';

interface Props {
  width?: string;
  height?: string;
  margin?: string;
}

const InfoIcon: React.FC<Props> = ({ width = '14', height = '14', margin = 'mr-3' }) => (
  <div className={clsx(margin)}>
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.00016 0.333252C3.32416 0.333252 0.333496 3.32392 0.333496 6.99992C0.333496 10.6759 3.32416 13.6666 7.00016 13.6666C10.6762 13.6666 13.6668 10.6759 13.6668 6.99992C13.6668 3.32392 10.6762 0.333252 7.00016 0.333252ZM7.50016 10.1666C7.50016 10.4426 7.27616 10.6666 7.00016 10.6666C6.72416 10.6666 6.50016 10.4426 6.50016 10.1666V6.49992C6.50016 6.22392 6.72416 5.99992 7.00016 5.99992C7.27616 5.99992 7.50016 6.22392 7.50016 6.49992V10.1666ZM7.00016 4.99992C6.63183 4.99992 6.3335 4.70158 6.3335 4.33325C6.3335 3.96492 6.63183 3.66658 7.00016 3.66658C7.3685 3.66658 7.66683 3.96492 7.66683 4.33325C7.66683 4.70158 7.3685 4.99992 7.00016 4.99992Z"
        fill="#187A90"
      />
    </svg>
  </div>
);

export default InfoIcon;
